/**
 * Post-processes resume text for final output
 * @param text Resume text to process
 * @returns Processed resume text
 */
export function postProcessResume(text: string): string {
  return text
    // Remove excessive newlines
    .replace(/\n{3,}/g, '\n\n')
    // Fix spacing before punctuation
    .replace(/\s+([.,;:!?])/g, '$1')
    // Ensure consistent section headers
    .replace(/^(#\s*[A-Za-z\s]+)$/gm, match => match.toUpperCase())
    // Remove any trailing whitespace
    .trim();
}
